import { NgModule } from '@angular/core';
import { Routes, RouterModule } from '@angular/router';
import { EmployeeDashboardComponent } from '../common/employee-dashboard/employee-dashboard.component';
import { DashboardEmployeeComponent } from './dashboard-employee/dashboard-employee.component';
import { CommonModule } from '@angular/common';
import { TimesheetEntryComponent } from './timesheet-entry/timesheet-entry.component';
import { NotificationComponent } from '../common/notification/notification.component';
import { EmployeeGuard } from './employee.guard';
import { ProjectComponent } from './project/project.component';
import { TimeSheetApprovalListComponent } from './time-sheet-approval-list/time-sheet-approval-list.component';
import { TimesheetApprovalsComponent } from '../rm/timesheet-approvals/timesheet-approvals.component';
import { RejectedTimesheetDetailsComponent } from '../employee/rejected-timesheet-details/rejected-timesheet-details.component';
import { ProfileComponent } from '../common/profile/profile.component';
const routes: Routes = [
  {
    path: 'employee',
    component: EmployeeDashboardComponent,
    canActivate: [EmployeeGuard],
    canActivateChild: [EmployeeGuard],
    children: [
      {
        path: '',
        component: DashboardEmployeeComponent
      },
      {
        path: 'dashboard',
        component: DashboardEmployeeComponent,
      },
      {
        path: 'profile',
        component: ProfileComponent,
      },
      {
        path: 'timesheet-approval',
        component: TimesheetApprovalsComponent,
      },
      {
        path: 'timesheet-entry',
        component: TimesheetEntryComponent,
      },
      {
        path: 'timeSheetApprovalsList',
        component: TimeSheetApprovalListComponent,
      },
      {
        path: 'timeSheetRejectedList',
        component: RejectedTimesheetDetailsComponent,
      },
      {
        path: 'notification',
        component: NotificationComponent,
      },
      {
        path: 'project',
        component: ProjectComponent,
      }
    ]
  }
];

@NgModule({
  imports: [RouterModule.forChild(routes)],
  exports: [RouterModule]
})
export class EmployeeRoutingModule { }



// WEBPACK FOOTER //
// ./src/app/employee/employee-routing.module.ts